import { useContext, useEffect, useState } from 'react';
import { back } from '../../helpers/dataServer';
import { ItemSelect } from './ItemSelect';
import { UserContext } from '../auth/context/UserContext';

const ItemPefilUsuario = ({ usuario }) => {
  const [perfiles, setPerfiles] = useState([]);
  const [usuarioPerfil, setUsuarioPerfil] = useState();
  const [abierto, setAbierto] = useState(false);

  const { dataUser } = useContext(UserContext);

  const { token } = dataUser;

  useEffect(() => {
    setUsuarioPerfil(usuario.id_perfil);
  }, [usuario.id_perfil]);

  useEffect(() => {
    fetch(`${back}/perfiles/listperfilesusuario/${usuario.id}`, {
      headers: {
        authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data.data)) {
          setPerfiles(data.data);
        } else {
          setPerfiles([]); // previene errores posteriores
        }
      })

      .catch((error) => {
        console.error('Error al obtener la lista de perfiles:', error);
      });
  }, [token, usuario.id]);

  const toggleAcordeon = () => {
    setAbierto(!abierto);
  };

  const perfilesConComa = Array.isArray(perfiles) ? perfiles.join(' - ') : '';

  return (
    <section className="cardManagementProfile" onClick={toggleAcordeon}>
      <img
        className="imgGestPerfil"
        src={usuario.imagen}
        alt="Imagen de perfil"
      />
      <span className="nombreGestPerfil">
        {usuario.nombre} {usuario.apellido}
      </span>
      <span className="perfilesGest">
        {perfiles.length > 0 ? (
          <ItemSelect
            usuario={usuario}
            abierto={abierto}
            toggleAcordeon={toggleAcordeon}
            perfilesNombres={perfilesConComa}
          />
        ) : (
          <span style={{ fontStyle: 'italic', color: '#888' }}>
            <ItemSelect
              usuario={usuario}
              abierto={abierto}
              toggleAcordeon={toggleAcordeon}
              perfilesNombres={'Sin perfiles asignados'}
            />
          </span>
        )}
      </span>
    </section>
  );
};

export default ItemPefilUsuario;

// import { useContext, useEffect, useState } from 'react';
// import { back } from '../../helpers/dataServer';
// import { ItemSelect } from './ItemSelect';
// import { UserContext } from '../auth/context/UserContext';

// const ItemPefilUsuario = ({ usuario }) => {
//   const [perfiles, setPerfiles] = useState([]);
//   const [usuarioPerfil, setUsuarioPerfil] = useState();

//   const { dataUser } = useContext(UserContext);

//   const { token } = dataUser;

//   useEffect(() => {
//     setUsuarioPerfil(usuario.id_perfil);
//   }, []);

//   useEffect(() => {
//     fetch(`${back}/perfiles/listperfiles`, {
//       headers: {
//         authorization: token,
//         'Content-Type': 'application/json',
//       },
//     })
//       .then((response) => response.json())
//       .then((data) => setPerfiles(data.data))
//       .catch((error) => {
//         console.error('Error al obtener la lista de perfiles:', error);
//       });
//   }, []);

//   return (
//     <section className="cardManagementProfile">
//       <img
//         className="imgGestPerfil"
//         src={usuario.imagen}
//         alt="Imagen de perfil"
//       />
//       <span className="nombreGestPerfil">
//         {usuario.nombre} {usuario.apellido}
//       </span>
//       <span className="perfilesGest">
//         <ItemSelect usuario={usuario} />
//       </span>
//     </section>
//   );
// };

// export default ItemPefilUsuario;
